module.exports = __webpack_public_path__ + "static/media/house11lg.b9504a49.png";